import React from "react";

/* comp imports */
import EndSwitchInner from "./EndSwitchInner";

const EndSwitchButton = ({ exploreIn3dHandler, callGaHandler, isLastScreen = false }) => {
  return (
    <label className="switch-button">
      <input type="checkbox" onClick={() => {
        exploreIn3dHandler();
        callGaHandler("Explore_you_car_in_3D", isLastScreen ? "Last_screen" : "Story_screen");
      }} />
      <div>
        <EndSwitchInner />
      </div>
    </label>
  );
};

export default EndSwitchButton;
